import { Guid } from 'Lib/Guid';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi, catchWithAuthErrors } from '../../Helpers/rxjsHelpers';
import { SeparationModel } from './types';

export const callApiGetSeparations = (worksheetId: Guid) => {
  return callApi(webApi.soil.psdSieveAnalysisTests.separations.get({ worksheetId })).pipe(
    map((response) => response.Body)
  );
};

export const callApiPutSeparations = (worksheetId: Guid, separations: SeparationModel[]) => {
  return callApi(
    webApi.soil.psdSieveAnalysisTests.separations.put(
      { Body: { Id: worksheetId, Separations: separations } },
      { worksheetId }
    )
  ).pipe(catchWithAuthErrors((err: any) => throwError(err)));
};

export const callApiRefreshSieves = (worksheetId: Guid) => {
  return callApi(webApi.soil.psdSieveAnalysisTests.refreshSieves.post({}, { worksheetId })).pipe(
    catchWithAuthErrors((err: any) => throwError(err))
  );
};
